var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disabled-comment text-center",domProps:{"innerHTML":_vm._s(_vm.signedOutText)}})}
var staticRenderFns = []

export { render, staticRenderFns }